export const errorMessages = new Map();

errorMessages.set('ReviewWidget not found', 'Widget not found.');
errorMessages.set(
  "You don't have access to this feature on current plan.",
  "You don't have access to this feature on current plan."
);
